/**
 * IntakyAllFirmsPage — staff-only view of ALL firms' intakes on one map.
 * Route: /external/intake/all
 *
 * Reuses IntakyFirmPage exactly, pointed at the all-firms endpoints.
 */
import React from 'react';

import { IntakyFirmPage } from './IntakyFirmPage';

const API_BASE = import.meta.env.VITE_APP_DJANGO_BACKEND_HOST as string;

export const IntakyAllFirmsPage: React.FC = () => (
  <IntakyFirmPage
    overviewUrl={`${API_BASE}/api/intaky/all/overview/`}
    streamUrl={`${API_BASE}/api/intaky/all/stream/`}
  />
);
